import { QuillModules, QuillToolbarConfig } from 'ngx-quill';

// ========================== Quill Toolbar Config ==========================
//  [
//   ['bold', 'italic', 'underline', 'strike'], // toggled buttons
//   ['blockquote', 'code-block'],

//   [{ 'header': 1 }, { 'header': 2 }], // custom button values
//   [{ 'list': 'ordered' }, { 'list': 'bullet' }],
//   [{ 'script': 'sub' }, { 'script': 'super' }], // superscript/subscript
//   [{ 'indent': '-1' }, { 'indent': '+1' }], // outdent/indent
//   [{ 'direction': 'rtl' }], // text direction

//   [{ 'size': ['small', false, 'large', 'huge'] }], // custom dropdown
//   [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

//   [{ 'color': [] }, { 'background': [] }], // dropdown with defaults from theme
//   [{ 'font': [] }],
//   [{ 'align': [] }],

//   ['clean'], // remove formatting button

//   ['link', 'image', 'video'], // link and image, video
// ];

const QUILl_TOOLBAR_CONFIG: QuillToolbarConfig = [['bold', 'italic', 'underline', 'link']];

export const QUILl_OPTIONS: QuillModules = {
  toolbar: QUILl_TOOLBAR_CONFIG,
  keyboard: {
    bindings: {
      enter: {
        key: 13,
        handler: () => {
          // Prevent inserting a new line when enter is pressed
          return false;
        },
      },
    },
  },
};
